var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-null flex flex-j-c-center flex-a-i-center"},[_c('img',{attrs:{"src":require("@/assets/null.png")}}),_c('p',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }